/* LSM: In stock / Pre-order / Special order on the search results (Brandon, 2026-10-19: "When searching products there is no filter
   for in-stock/out of stock"). Shopify's own availability filter is no use here: every product keeps selling when it is out, so
   Shopify calls them all available. The store's own state is on each card (data-lsm-avail, snippets/card-product.liquid), the same
   one the collection filters read (assets/lsm-collection.js). A choice reads every page of the results once, shows the
   matching products in one list (up to 15 pages) and hides the page links; clearing it puts the page back as it was. */
(() => {
  const T = (k, en) => (window.LSM_T && window.LSM_T['lsm.jscoll.' + k]) || en
  const AVAIL = [['in', T('in_stock', 'In stock')], ['soon', T('pre_order', 'Pre-order')], ['order', T('special_order', 'Special order')]]
  const grid = document.getElementById('ProductsList')
  if (!grid) return
  const section = grid.closest('.shopify-section')
  const sectionId = section ? section.id.replace('shopify-section-', '') : ''
  const pager = section && section.querySelector('.pagination, nav[aria-label*="agination" i], .pagination-wrapper')
  const pages = Number(grid.dataset.lsmPages || 1)
  const original = [...grid.children]
  const on = new Set()
  let all = null
  const bar = document.createElement('div')
  bar.className = 'lsm-filters lsm-search-avail is-open'
  const note = document.createElement('p')
  note.className = 'lsm-search-avail__note text-subtext'
  note.hidden = true
  const draw = () => {
    bar.innerHTML = AVAIL.map(([k, label]) => `<button type="button" class="lsm-chip${on.has(k) ? ' is-on' : ''}" data-value="${k}" aria-pressed="${on.has(k)}"><span class="lsm-dot lsm-dot--${k}" aria-hidden="true"></span>${label}</button>`).join('') +
      (on.size ? '<button type="button" class="lsm-filters__clear" data-clear>' + T('clear', 'Clear') + '</button>' : '')
  }
  const availOf = (col) => col.querySelector('.product-card')?.dataset.lsmAvail || ''
  const readAll = async () => {
    if (all) return all
    const here = Number(grid.dataset.lsmPage || 1)
    const nums = []; for (let p = 1; p <= Math.min(pages, 15); p++) nums.push(p)
    // all pages at once, then kept in page order
    const read = await Promise.all(nums.map(async (p) => {
      if (p === here) return original
      const url = new URL(location.href); url.searchParams.set('page', String(p)); if (sectionId) url.searchParams.set('section_id', sectionId)
      try {
        const doc = new DOMParser().parseFromString(await fetch(url).then((r) => r.text()), 'text/html')
        return [...(doc.getElementById('ProductsList')?.children || [])]
      } catch (e) { console.warn('LSM search filter: could not read page', p, e); return [] }
    }))
    return (all = read.flat())
  }
  const apply = async () => {
    draw()
    // the pre-owned row is all in stock: it stays for "In stock" and steps aside for the other choices
    section?.querySelectorAll('.lsm-search-row, .lsm-search-row__title').forEach((el) => { el.hidden = on.size > 0 && !on.has('in') })
    if (!on.size) { grid.replaceChildren(...original); if (pager) pager.hidden = false; note.hidden = true; return }
    bar.classList.add('is-busy')
    if (!all) { note.hidden = false; note.textContent = T('search_looking', 'Looking through every result…') }
    const cols = await readAll()
    bar.classList.remove('is-busy')
    const hits = cols.filter((c) => on.has(availOf(c)))
    grid.replaceChildren(...hits)
    if (grid.getBoundingClientRect().top < 0 || grid.getBoundingClientRect().top > innerHeight) note.scrollIntoView({ block: 'start', behavior: 'smooth' })
    if (pager) pager.hidden = true
    note.hidden = false
    note.textContent = hits.length ? (hits.length === 1 ? T('n_product', '{n} product') : T('n_products', '{n} products')).replace('{n}', hits.length) : T('search_none', 'Nothing here matches. Clear the filter to see every result.')
  }
  bar.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return
    if (b.hasAttribute('data-clear')) on.clear(); else { const k = b.dataset.value; on.has(k) ? on.delete(k) : on.add(k) }
    apply()
  })
  draw()
  // in the results bar at the top (it stays in view), beside the count; the count of matches goes above the grid
  const toolbar = section && section.querySelector('.collection__toolbar-left')
  if (toolbar) toolbar.prepend(bar); else grid.before(bar)
  grid.before(note)
})()
